import { apiEndpoint } from "../utils/env";

async function fetchWithAuth(url, token, options = {}) {
  const headers = options.headers || {};
  if (token) headers["Authorization"] = `Bearer ${token}`;
  headers["Content-Type"] = headers["Content-Type"] || "application/json";
  const res = await fetch(url, { ...options, headers });
  const txt = await res.text();
  let json = null;
  try {
    json = txt ? JSON.parse(txt) : null;
  } catch {
    json = txt;
  }
  if (!res.ok) {
    const errMsg =
      json && json.message
        ? json.message
        : typeof json === "string"
        ? json
        : res.statusText;
    const error = new Error(errMsg || `Request failed: ${res.status}`);
    error.code = json && json.code ? json.code : null;
    error.status = res.status;
    error.details = json;
    throw error;
  }
  return json;
}

// Metadata Schema APIs
export async function getSchemas(token, includeInactive = false) {
  const url = apiEndpoint(
    `/api/MetadataSchema?includeInactive=${includeInactive}`
  );
  return fetchWithAuth(url, token, { method: "GET" });
}

export async function getSchema(token, schemaId) {
  const url = apiEndpoint(`/api/MetadataSchema/${schemaId}`);
  return fetchWithAuth(url, token, { method: "GET" });
}

export async function createSchema(token, schemaData) {
  const url = apiEndpoint("/api/MetadataSchema");
  return fetchWithAuth(url, token, {
    method: "POST",
    body: JSON.stringify(schemaData),
  });
}

export async function updateSchema(token, schemaId, schemaData) {
  const url = apiEndpoint(`/api/MetadataSchema/${schemaId}`);
  return fetchWithAuth(url, token, {
    method: "PUT",
    body: JSON.stringify(schemaData),
  });
}

export async function deleteSchema(token, schemaId) {
  const url = apiEndpoint(`/api/MetadataSchema/${schemaId}`);
  return fetchWithAuth(url, token, { method: "DELETE" });
}

export async function assignSchemaToDatabase(token, databaseId, schemaId) {
  const url = apiEndpoint("/api/MetadataSchema/AssignToDatabase");
  return fetchWithAuth(url, token, {
    method: "POST",
    body: JSON.stringify({ databaseId, schemaId }),
  });
}
